import { TContentSection } from '@/modules/content/loop/model/contentDetails';

// Average adult reading speed, used to turn a word count into a "N min read" estimate.
const WORDS_PER_MINUTE = 200;

export const wordCount = (text?: string): number => (text ? text.trim().split(/\s+/).filter(Boolean).length : 0);

// A section's length includes its subsections — they are read as part of it.
export const sectionWords = (section: TContentSection & { subsections?: { text?: string }[] }): number =>
  wordCount(section.text) + (section.subsections ?? []).reduce((sum, sub) => sum + wordCount(sub.text), 0);

export const readingTime = (words: number): string => `${Math.max(1, Math.round(words / WORDS_PER_MINUTE))} min read`;
